<script setup lang="ts">
import { useRouter } from 'vue-router'
import AppIcon from './AppIcon.vue'

const props = withDefaults(defineProps<{ to: string; label?: string }>(), {
  label: '返回',
})

const router = useRouter()

function handleBack(event: MouseEvent) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  event.preventDefault()
  const historyState = router.options.history.state as { back?: unknown }

  if (typeof historyState?.back === 'string' && historyState.back) {
    router.back()
    return
  }

  router.replace(props.to)
}
</script>

<template>
  <a class="app-back" :href="to" :aria-label="label" @click="handleBack">
    <AppIcon name="caret-left" :size="18" />
    <span>{{ label }}</span>
  </a>
</template>

<style scoped>
.app-back{display:inline-flex;min-height:36px;margin-bottom:18px;align-items:center;gap:4px;color:var(--rio-blue);font-size:13px;font-weight:700}.app-back .app-icon{flex:0 0 auto}.app-back:hover span{text-decoration:underline;text-underline-offset:3px}
</style>
